"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _react = _interopRequireDefault(require("react"));
var _ThemeSpacing = _interopRequireDefault(require("../Theme/ThemeSpacing.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Container
 * 
 * MIGRATION NOTES: singleColumn -> columnar
 *
 * A base grid container.
 *
 * @package HOPS
 * @subpackage Components
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */class Container extends _react.default.Component {
  /**
   * Render.
   *
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      ...this.forwards,
      ref: this.props.rootRef,
      style: this.styles,
      children: this.props.children
    });
  }

  /**
   * Get the `grid-template-columns` value to use.
   * 
   * @return {String} CSS
   */
  get columns() {
    if (this.props.columns) return this.props.columns;else return !this.props.columnar ? "100%" : null;
  }

  /**
   * Get the `gap` value to use.
   * 
   * @return {Integer}
   */
  get gap() {
    return this.props.gap !== undefined ? this.props.gap : 1;
  }

  /**
   * Get props to forward.
   *
   * @return {Object}
   */
  get forwards() {
    const props = {};
    this.constructor.propForwards.forEach(prop => {
      if (this.props.hasOwnProperty(prop)) {
        props[prop] = this.props[prop];
      }
    });
    return props;
  }

  /**
   * Styles.
   * 
   * @return {Object}
   */
  get styles() {
    return {
      alignContent: this.props.alignContent,
      alignItems: this.props.alignItems,
      alignSelf: this.props.alignSelf,
      display: this.props.display || "grid",
      gap: (0, _ThemeSpacing.default)(this.props.gap !== undefined ? this.props.gap : 1),
      gridAutoColumns: this.props.gridAutoColumns,
      gridAutoFlow: this.props.columnar ? "column" : "row",
      gridAutoRows: this.props.autoRows || "max-content",
      gridTemplateColumns: this.columns,
      gridTemplateRows: this.props.gridTemplateRows,
      height: this.props.height,
      justifyContent: this.props.justifyContent,
      justifyItems: this.props.justifyItems || (this.props.centred ? "center" : null),
      justifySelf: this.props.justifySelf,
      maxWidth: this.props.maxWidth,
      minHeight: this.props.minHeight,
      order: this.props.order,
      overflow: this.props.overflow,
      textAlign: this.props.textAlign,
      width: this.props.fullWidth ? "100%" : this.props.width,
      ...this.props.style
    };
  }

  /**
   * Props we forward to our underlying `mui` `Box`.
   * 
   * @type {Array}
   */
  static propForwards = ["classes", "className", "component", "mb", "ml", "mr", "mt", "mx", "my", "pb", "pl", "pr", "pt", "px", "py"];
}
var _default = exports.default = Container;